/* @flow */
import * as React from "react";
import { lighten } from "polished";
import {
  withColorsProvider,
  type ColorSet,
} from "nx-components/ColorsProvider";

type Props = {
  headline: string,
  publishedDate: Date,
  content: string,
  colors: ColorSet,
};

class NewsPage extends React.Component<Props> {
  render() {
    const { headline, publishedDate, content, colors } = this.props;

    const styles = {
      headline: {
        fontSize: "1.2em",
      },
      content: {
        color: colors.TEXT_SECONDARY,
        margin: "0.5em 0",
        fontSize: "0.8em",
      },
      date: {
        color: lighten(0.2, colors.TEXT_SECONDARY),
        fontSize: "0.75em",
      },
    };

    return (
      <div data-component-name="NewsPage">
        <div data-component-section="headline" style={styles.headline}>
          {headline}
        </div>
        {/* eslint-disable react/no-danger */}
        <div
          style={styles.content}
          data-component-section="content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
        {/* eslint-enable react/no-danger */}
        <div data-component-section="date" style={styles.date}>
          {publishedDate.toDateString()}
        </div>
      </div>
    );
  }
}

export default withColorsProvider(NewsPage);



// WEBPACK FOOTER //
// ./src/components/News/NewsPage.jsx